import React, { useCallback, useEffect, useState } from 'react';
import { GridContainer, Grid } from 'src/shared/grid';
import { Formik, Form } from 'formik';
import Select from '@mui/material/Select';
import { FormControlLabel, MenuItem, Switch, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import 'src/features/field-sample//FieldSample.scss';
import * as Yup from 'yup';
import { useAddAlert } from 'src/store/actions';
import { useStoreContext } from 'src/store/context';
/*import { useHistory } from 'react-router-dom';
import { alertMessages } from 'src/constants';*/
import { TextareaAutosize } from 'src/shared/Styles/Styles';
import FormHelperText from '@mui/material/FormHelperText';
import { createUpdateReport, getReports } from 'src/apis/mutationsReports';
import { alertMessages } from 'src/constants';
import { errorResponse } from 'src/store/common';


export const validationSchema = Yup.object().shape(
  {
    reportUrl: Yup.string().nullable()
      .required('Report URL is Required'),
    reportTitle: Yup.string()
      .required('Report Title is Required'),
    reportDescription: Yup.string()
      .required('Report Description is Required'),
    reportType: Yup.string()
      .required('Report Type is Required'),
  }
);

type ReportProps ={
  setOpen: any,
  setCreateUpdateReportSuccess: any,
  typeFromParam: string,
  editReport?: any,
}
interface FormVals {
  reportId: number|null,
  reportUrl: string,
  reportTitle: string,
  reportDescription: string,
  reportType:string,
  reportVisible: boolean,
}
export const AddReport: React.FC<ReportProps> = ({setOpen, typeFromParam, setCreateUpdateReportSuccess, editReport}) =>{
  
  /*const [, setCallComplete] = useState<boolean>(true);
  const history = useHistory();
  */

  const [, dispatch] = useStoreContext();
  const addAlert = useAddAlert(dispatch);
  const [prefixError, setPrefixError] = useState<string>('')

  const [initVals, setInitVals] = useState<FormVals>({
    reportId: null,
    reportUrl: '',
    reportTitle: '',
    reportDescription:'',
    reportType: typeFromParam,
    reportVisible: true,
  })

  const handleSubmit= (values:any)=>{
    (async()=>{
      try{
        const paramsToSend = {
          id: values.reportId,
          title: values.reportTitle,
          description: values.reportDescription,
          type: values.reportType,
          url: values.reportUrl,
          visible: values.reportVisible
        }
        const response:any = await createUpdateReport(paramsToSend, addAlert);
        if(response?.data.data.createUpdatePowerBIReport.message?.length>0){
          setCreateUpdateReportSuccess(true)
          //save banner
          if(values.reportId===null){
            errorResponse('', addAlert, `The report, ${response.data.data.createUpdatePowerBIReport.data.title}, was saved.`, true);
          }
          else{
            errorResponse('', addAlert, `The changes to the report, ${response.data.data.createUpdatePowerBIReport.data.title}, was saved.`, true);
          }
          
          setOpen(false)
        }
      }
      catch(error:any){
        console.log('error', error);
        addAlert({
          id: '',
          message: alertMessages.report,
          type: 'error-info',
          icon: 'fa-exclamation-triangle'
        })
      }
    })();
  }
  /** Make an API call to populate the initVals when editing an area */
    const getReportById = useCallback(() => {
        (async () => {
            try {
                const varRequest = {
                    sortBy: 'title',
                    sortOrder: 'asc',
                    page: 0,
                    perPage: 1000,
                    type: null, 
                    id:editReport,
                    visible: 'ALL'
                };
                const response: any = await getReports(varRequest, addAlert);
                if (response) {
                   let editVals={
                    reportId: response[0].id,
                    reportUrl: response[0].url,
                    reportTitle: response[0].title,
                    reportDescription:response[0].description,
                    reportType: typeFromParam,
                    reportVisible: response[0].visible
                  }
                   setInitVals(editVals)
                }
            }
            catch (error) {
                addAlert({
                    id: '',
                    message: alertMessages.reportGet,
                    type: 'error-info',
                    icon: 'fa-exclamation-triangle'
                })
            }
        })();
    }, [addAlert, editReport, typeFromParam]);

  /* use Effect to check and make a call to get the edit area */
  useEffect(()=>{
      if(editReport){
        getReportById()
      }
      else{
        let initValues={
          reportId: null,
          reportUrl: '',
          reportTitle: '',
          reportDescription:'',
          reportType: typeFromParam,
          reportVisible: true
        }
        setInitVals(initValues);
      }

  },[addAlert, editReport, typeFromParam, getReportById]);
  
  return(
  <GridContainer className="removePadding smooth-scrollbar" style={{height: '80%', maxHeight: '95%', minHeight:'50%', overflowX: 'hidden', paddingBottom: '2rem'}}>
    <Grid row gap="md" className='page-heading'>
      <Grid
        desktop={{col:12}}
        className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 paddingForModal">
          {
            editReport ? (
              <span className="font-sans-lg text-bold">Edit Report</span>
            ):(
              <span className="font-sans-lg text-bold">Add a New Report</span>
            )
          }
      </Grid>
    </Grid>
    <hr style={{width: '100%', marginBottom: '2rem', marginTop: '2rem'}}></hr>

    <Formik
      initialValues={initVals}
      validateOnBlur={true}
      validateOnChange={true}
      validateOnMount={true}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={(values) => handleSubmit(values) }>
      {({
        values,
        errors,
        touched,
        handleSubmit,
        setFieldValue,
        isValid,
        setFieldTouched
      }) => { 
        
        const validateUrl = (event: any) => {
          const prefix='https://app.powerbigov.us/'
          let stringEntered:string = event.target.value;
          if(!stringEntered.startsWith(prefix)){
            setPrefixError('URL does not match expected powerbi source')
          }
          else{
            setPrefixError('')
          }
          
        }
        
        const setValue=(event: any, type:string)=>{
          setFieldTouched(type);
          
          if(event.target.value.length ===1 && /^\s/.test(event.target.value)){
            return
          }

          if(type==='reportVisible'){
            setFieldValue(type, event.target.checked);
          }
          
          else{
            setFieldValue(type, event.target.value);
          }
        }

        return(
          <Form onSubmit={handleSubmit}>
            <div className="paddingForm">
              <FormControlLabel
                control={
                  <Switch
                    checked={values.reportVisible}
                    onChange={(e: any) => setValue(e, 'reportVisible')}
                    size="medium"
                    color="primary"
                    inputProps={{ 'aria-label': 'Visible' }}
                  />
                }
                label="Visible"
              />
              {/* ****  TITLE  **** */}

              <Grid row desktop={{ col: 7 }}>
                <label id='createUpdateReportTitle' htmlFor='createUpdateReportTitle'>Title*</label>
                <TextField
                  value={values.reportTitle}
                  onBlur={()=> setFieldTouched('reportTitle')}
                  error={!!errors.reportTitle && !!touched.reportTitle}
                  helperText={errors.reportTitle && touched.reportTitle ? errors.reportTitle : ''}
                  id='createUpdateReportTitle'
                  type='string'
                  size='medium'
                  fullWidth
                  onChange={(e: any) => setValue(e, 'reportTitle')}
                  placeholder='Enter Title'
                />
              </Grid>
              {/* ****  URL  **** */}
              <Grid row desktop={{ col: 7 }}>
                <label id='createUpdateURL' htmlFor='createUpdateURL'>URL*</label>
                <TextField
                  value={values.reportUrl}
                  onBlur={()=> setFieldTouched('reportUrl')}
                  error={!!touched.reportUrl &&(!!errors.reportUrl || prefixError?.length>1 )}
                  onInput={(e) => validateUrl(e)}
                  helperText={!!errors.reportUrl && !!touched.reportUrl ? errors.reportUrl : ''}
                  id='createUpdateURL'
                  type='string'
                  size='medium'
                  fullWidth
                  onChange={(e: any) => setValue(e, 'reportUrl')}
                  placeholder='Enter URL'
                />
                {touched.reportUrl && prefixError?.length>1 &&
                <FormHelperText style={{paddingLeft:'1rem', paddingTop:'.7rem', color:'#d32f2f'}}>
                  {prefixError}
                </FormHelperText>
                }
              </Grid>
              <Grid row desktop={{ col: 7 }}>
                <label id='createUpdateReportType'>Report Type*
                <Select
                  value={values.reportType}
                  labelId='createUpdateReportType'
                  onChange={(e: any) => setValue(e, 'reportType')}
                  onBlur={()=> setFieldTouched('reportType')}
                >
                  <MenuItem value={'nfdrs'}>Fire Danger</MenuItem>
                  <MenuItem value={'weather'}>Weather</MenuItem>
                  <MenuItem value={'station_information'}>Station Information</MenuItem>
                  <MenuItem value={'field_sample'}>Field Sample</MenuItem>
                  <MenuItem value={'advanced_analytics'}>Advanced Analytics</MenuItem>

                </Select>
                </label>
              </Grid>
              <Grid row desktop={{ col: 12 }}>
                <label htmlFor='createUpdateReportDescription' 
                  style={{paddingBottom: '.5rem'}}
                >Description*
                <TextareaAutosize 
                  style={touched.reportDescription && errors.reportDescription? {width:'100%', borderColor:'red', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontSize:'1rem'}:{width:'100%', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontSize:'1rem'}}
                  value={values.reportDescription}
                  onBlur={()=> setFieldTouched('reportDescription')}
                  minRows={3}
                  placeholder="Enter Description"
                  onChange={(e: any) => setValue(e, 'reportDescription')}
                  id='createUpdateReportDescription'
                  aria-label='createUpdateReportDescription'
                />
                </label>
                {touched.reportDescription && errors.reportDescription &&
                <FormHelperText style={{paddingLeft:'1rem', paddingTop:'.7rem', color:'#d32f2f'}}>
                  {errors.reportDescription}
                </FormHelperText>
                }
              </Grid>
            </div>

            <Grid row className='modalBottomDiv'>
              <Grid desktop={{col:10}} className="modalCancelDiv">
                <Button variant="outlined" style={{backgroundColor: 'white'}} onClick={()=>{setOpen(false)}}>
                  Cancel
                </Button>
              </Grid> 
              {
                editReport ? (
                  <Grid desktop={{col:2}} className='modalSubmitDiv'>
                    <Button variant="contained" type="submit" aria-disabled={!isValid || prefixError?.length>1}>
                      Save
                    </Button>
                  </Grid>
                ) : (
                  <Grid desktop={{col:2}} className='modalSubmitDiv'>
                    <Button variant="contained" type="submit" aria-disabled={!isValid || prefixError?.length>1}>
                      Add
                    </Button>
                  </Grid>
                )
              }
            </Grid>
          </Form>
      )}}
    </Formik>
  </GridContainer>
  )
}